<!-- 选择组件 --> 
<template>
  <div class="check-container" :class="statue?'check-disable':''" @click="handleClick">
    <div class="check-icon-sty-wrap" :class="flag==1?'backg-wh':''" >
      <i class="check-icon-sty" :class="flag==1?'no-select':(flag==2?'el-icon-check':'el-icon-minus')"></i>
    </div>
    <div class="label"><slot></slot></div>
  </div>
</template>
<script>
export default {
  name: "Check",
  // value 传进来的值，isDisable 是否不可点击（目前是传所有者），
  props:["itemValue","isDisable"],
  data() {
    return {
      flag: 1,                      // 1 全不选 2全选 3非全选且非全不选
    };
  },
  methods: {
    handleClick() {
      if(!this.isDisable) {
        this.$emit('select',this.itemValue)
      }
    },
  },
  watch: {
    itemValue: {
      handler(newVal,oldVal) {
        if(newVal) {
          this.flag = newVal.flag;
        }
      },
      deep: true,
      immediate:true
    },
    isDisable: {
      handler(newVal,oldVal) {
      },
      immediate:true
    },
  },
  computed: {
    statue() {
      return this.isDisable
    },
  }
};
</script>
<style lang="scss" scoped>
.check-disable {
  cursor: not-allowed !important;
  .check-icon-sty-wrap {
    background-color: #D7D7D7 !important;
    border:1px solid #D7D7D7 !important;
  }
  .label {
    color: #AAAAAA !important;
  }
}
.check-container {
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  .check-icon-sty-wrap {
    height: 15px;
    width: 15px;
    border: 1px solid #2684FF;
    box-sizing: border-box;
    display: flex;
    border-radius: 2px;
    background-color: #409EFF;
    color: white;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .backg-wh {
    background-color: white !important;
  }
  .check-icon-sty {
    height: 14px;
    width: 14px;
    font-size: 14px;
    font-weight: bold;
    transform: scale(0.6);
  }
  .label {
    font-size: 13px;
    color: #555555;
    margin-left: 8px;
  }
  .no-select {
    background-color: white;
  }
}

</style>